/** Cap devicePixelRatio for WebGL (tablets / high-DPR laptops) to reduce fill-rate cost on zoom. */
export const WEBGL_DPR: [min: number, max: number] = [1, 1.5]

/**
 * Dual viewport runs two full renders per frame.
 * Cap at 2 to stay sharp on Retina displays (2× DPR) without exceeding native resolution.
 */
export const WEBGL_DPR_DUAL_BODY: [min: number, max: number] = [1, 2]
